import { ScheduleSetting } from '../../../store/ScheduleSettings';

// The api sends portal_user_id as a number while the session carries the id as a string, so both sides coerce —
// and both must be present, or two absent ids would stringify equal and make an unowned schedule look like yours.
export const isScheduleOwner = (
  schedule: ScheduleSetting | null | undefined,
  userId: string | number | null | undefined
): boolean => {
  const ownerId = schedule?.portal_user_id;
  if (ownerId == null || userId == null || userId === '') return false;

  return String(ownerId) === String(userId);
};
